import { Card, Col, Row, Table } from "antd";
import React from "react";
import logoImg from "../../images/logo.jpg";
import { ColumnProps } from "antd/es/table";
import "./style.css";

const Index = () => {
  const dataSource = [
    {
      key: "1",
      a1: "0001",
      a2: "2020-01-03",
      a3: "-",
      a4: "030109901",
      a5: "网银",
      a6: "-",
      a7: "-",
      a8: "2020-08-01",
      a9: "340,000",
    },
    {
      key: "2",
      a1: "0002",
      a2: "2020-01-09",
      a3: "-",
      a4: "030109901",
      a5: "网银",
      a6: "-",
      a7: "-",
      a8: "2020-08-01",
      a9: "940,000",
    },
    {
      key: "3",
      a1: "0003",
      a2: "2020-01-10",
      a3: "-",
      a4: "030109901",
      a5: "网银",
      a6: "-",
      a7: "-",
      a8: "2020-08-01",
      a9: "440,000",
    },
  ];

  const columns: ColumnProps<any>[] = [
    {
      title: "合同编号",
      dataIndex: "a1",
      key: "a1",
      align: "center",
    },
    {
      title: "合同时间",
      dataIndex: "a2",
      key: "a2",
      align: "center",
    },
    {
      title: "合同商品",
      dataIndex: "a3",
      key: "a3",
      align: "center",
    },
    {
      title: "应收账款编号",
      dataIndex: "a4",
      key: "a4",
      align: "center",
    },
    {
      title: "付款方式",
      dataIndex: "a5",
      key: "a5",
      align: "center",
    },
    {
      title: "债权人",
      dataIndex: "a6",
      key: "a6",
      align: "center",
    },
    {
      title: "付款方",
      dataIndex: "a7",
      key: "a7",
      align: "center",
    },
    {
      title: "应收账款到期日",
      dataIndex: "a8",
      key: "a8",
      align: "center",
    },
    {
      title: "应收账款金额",
      dataIndex: "a9",
      key: "a9",
      align: "center",
    },
  ];

  return (
    <div className="homes">
      {/* <Card>
        <header>
          <div className="img">
            <img src={logoImg} alt="" />
          </div>
          <div className="text">
            <div className="title">你好，管理员</div>
            <div className="desc">最近登录：2020-04-05 12：31：37</div>
          </div>
        </header>
      </Card> */}

      <Card title="应收账款" style={{ marginTop: "20px" }} className="messages">
        <Row gutter={24} className="rows">
          <Col span={24} className="cols">
            <Card>
              {/* <h2 style={{ textAlign: "center" }}>应付账款</h2> */}
              <Table
                dataSource={dataSource}
                columns={columns}
                pagination={false}
              />
            </Card>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default Index;
